document.addEventListener( 'DOMContentLoaded', function() {
    var splideReview = new Splide( '.review-splide',{
        pagination: false, 
        type   : 'loop',
        gap: 80,
        perPage: 4,
        perMove: 1,
        classes: {
            arrows: 'splide__arrows i-article-arrows splide-review-arrows',
            arrow : 'splide__arrow i-article-arrow splide-review-arrow',
            prev  : 'splide__arrow--prev i-article-prev splide-review-arrows-prev',
            next  : 'splide__arrow--next i-article-next splide-review-arrows-next',
        },
       breakpoints: {
            1279: {
                gap: 40,
            },
            959: {
                perPage: 3,
            },
             743: {
                perPage: 1,
               gap: 63,
            }
        }
    } );
    splideReview.mount();
} );